/* This is the Root component mainly initializes Redux and React Router. */

import "./i18n";
import React from "react";
import { Provider } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ReduxRouter } from "@lagunovsky/redux-react-router";
import store from "./common/store";
import routeConfig from "./common/routeConfig";
import history from "./common/history";
import { App } from "./features/home";

import OfferGate from "./features/dashboard/components/OfferGate";

const standaloneRoutes = routeConfig.standaloneRoutes.map((item) => (
  <Route key={item.path} element={item.component} path={item.path} />
));

const DashboardLayout = routeConfig.dashboardRoute.component;
const dashboardRoutes = routeConfig.dashboardRoute.childRoutes.map((item) => {
  const Screen = item.component;
  return item.isIndex ? (
    <Route key="dashboard-index" index element={<OfferGate path={item.path}><Screen /></OfferGate>} />
  ) : (
    <Route key={item.path} path={item.path} element={<OfferGate path={item.path}><Screen /></OfferGate>} />
  );
});

function Root() {
  return (
    <Provider store={store}>
      <ReduxRouter history={history}>
        <Routes>
          {standaloneRoutes}
          <Route
            path="/"
            element={
              <App>
                <DashboardLayout />
              </App>
            }
          >
            {dashboardRoutes}
          </Route>
        </Routes>
      </ReduxRouter>
    </Provider>
  );
}

export default Root;
